import React from 'react';
import { observer } from "mobx-react";
import SearchPanel from './SearchPanel';
import {Card} from 'antd';
import {translateText} from "../../stores/objects/I18n"


const InputMenus = observer(({store, inputRef}) => {
      return (
            <Card bordered={false} 
                  bodyStyle={{padding: "10"}}
                  headStyle={{bordered: false}} 
                  title={
                    <span style={{color : "white"}}>
                        {translateText(store, "Searches")}
                    </span>
                  }
            >
        <SearchPanel store={store} inputRef={inputRef}/>
        </Card>
      );
});

export default InputMenus;
